<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="orders"
    :pagination.sync="pagination"
    :total-items="totalRows"
    :loading="loading"
    :rows-per-page-items="[10]"
    class="elevation-1"
  >
    <template slot="headerCell" slot-scope="props">{{ props.header.text | t }}</template>

    <template slot="items" slot-scope="props">
      <tr>
        <td class="text-xs-left">{{ props.item.id }}</td>
        <td class="text-xs-left">{{ props.item.billing_date | date }}</td>
        <td class="text-xs-left" v-if="props.item.type === 0">{{ 'billing.web' | t }}</td>
        <td class="text-xs-left" v-if="props.item.type === 1">{{ 'billing.autorenew' | t }}</td>
        <td class="text-xs-left" v-if="props.item.type === 2">{{ 'billing.manual' | t }}</td>
        <td class="text-xs-left">{{ props.item.product_type }} {{ props.item.product_name }}</td>
        <td class="text-xs-left">{{ props.item.total_price | currency }} &euro;</td>
        <td class="text-xs-left">
          <v-btn small @click="goOrder(props.item.id)">
            <v-icon small color="green" v-if="props.item.status === 2">check_circle</v-icon>
            <v-icon small color="grey" v-if="props.item.status === 0">error</v-icon>
            <v-icon
              small
              color="red"
              v-if="props.item.status === 3 || props.item.status === 4"
            >cancel</v-icon>
            {{ 'billing.order' | t }}
          </v-btn>
        </td>
        <td class="text-xs-left">
          <v-btn v-if="props.item.status === 2" small @click="goInvoice(props.item.billing_id)">
            <v-icon small color="grey">assignment_turned_in</v-icon>
            {{ 'billing.invoice' | t }}
          </v-btn>
        </td>
      </tr>
    </template>
    <template slot="no-data">{{ 'billing.no_data' | t }}</template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["user"],
  data() {
    return {
      search: "",
      selected: [],
      headers: [
        { text: "billing.id", value: "id", sortable: false },
        {
          text: "billing.billing_date",
          value: "billing_date",
          sortable: false
        },
        { text: "billing.transaction_type", value: "type", sortable: false },
        { text: "billing.product_name", value: "Total price", sortable: false },
        { text: "billing.price", value: "Total price", sortable: false },
        { text: "billing.view_order", value: "status", sortable: false },
        { text: "billing.view_invoice", value: "status", sortable: false }
      ],
      totalRows: 0,
      orders: [],
      loading: false,
      pagination: {}
    };
  },
  computed: {
    ...mapGetters(["getTokenHeader", "getServer", "getUserId"])
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      }
    }
  },
  methods: {
    goOrder(id) {
      this.$router.push({ path: "/order/" + id });
    },
    goInvoice(id) {
      this.$router.push({ path: "/invoice/" + id });
    },
    getData() {
      this.loading = true;
      const userid = this.user ? parseInt(this.user, 0) : this.getUserId;
      this.$http
        .get(
          `${this.getServer}/billing/${userid}?page=${this.pagination.page -
            1}`,
          this.getTokenHeader
        )
        .then(data => {
          if (data.data && data.data.orders && data.data.totalRows) {
            this.orders = data.data.orders;
            this.orders = this.orders;
            this.totalRows = data.data.totalRows;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style>
.invoicecolor {
  background-color: #cfd8dc;
}
</style>
